
























import { Component, Inject, Mixins } from "vue-property-decorator";

// Mixins
import Context from "@/mixins/context";

// Types
import { IBasketProviderData } from "@/models/providers/baskets";

@Component
export default class BasketButton extends Mixins(Context) {
  // Inject
  @Inject({ from: "providerData" })
  public readonly $providerData!: () => IBasketProviderData;

  // Provider
  public get basketData() {
    return this.$providerData();
  }

  public get basket() {
    return this.$_.get(this.basketData, "basket");
  }
}
